/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { IXandrBannerAdObject } from "@almamedia/amr-adtech-stack/lib/services/ads/adrequest";
import { IPlacementsConfiguration } from "@almamedia/amr-adtech-stack/lib/services/ads/adsservice";
import { nativeLinkedInConditions } from "@almamedia/amr-adtech-stack/lib/services/native/templates/native-linkedin-ad";
import { detectProgrammaticWallpaper } from "./custom-needs/custom-needs";
import { ICustomVariables } from "../data-layer/data-layer";
import { SiteNativeTemplate } from "../native/native";

const talouselamaPlacements: IPlacementsConfiguration<
  ICustomVariables,
  SiteNativeTemplate
> = {
  desktop_section_wide: [
    {
      divId: "almad-wallpaper-1",
      placementId: 13655196,
      sizes: [[1600, 1200]],
      friendlyName: "Talouselama.fi_ROS_1600x1200_(dynaaminen tapetti)",
    },
    {
      divId: "almad-giantBox-1",
      placementId: 9797505,
      sizes: [
        [490, 600],
        [490, 400],
        [468, 672],
        [468, 600],
        [468, 400],
        [300, 300],
        [300, 250],
        [320, 320],
        [320, 300],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName:
        "Talouselama.fi_ROS_468x400|300x250_yla2_(jättiboksi,boksi)",
      prebid: {
        active: true,
        source: "Talouselama_ROS_NordicGiantRectangle",
      },
      native: {
        template: "native_rectangle_orange",
      },
    },
    {
      divId: "almad-giantBox-2",
      placementId: 12157134,
      sizes: [
        [490, 600],
        [490, 400],
        [468, 600],
        [468, 400],
        [300, 300],
        [300, 250],
        [320, 320],
        [320, 300],
        [4, 2],
      ],
      friendlyName:
        "Talouselama.fi_ROS_468x400|300x250_sima_(jättiboksi,boksi)",
      prebid: {
        active: true,
        source: "Talouselama_ROS_NordicGiantRectangle",
      },
      lazyload: {
        offset: {
          top: -200,
          bottom: 100,
        },
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 9797509,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [2, 1],
        [2, 2],
      ],
      friendlyName:
        "Talouselama.fi_ROS_980x400|980x120|728x90_yla2_(paraati,panorama,jättibanneri)",
      prebid: {
        active: true,
        source: "Talouselama_ROS_NordicParade",
      },
      customNeeds: {
        adAvailable: (context, adObject): void => {
          detectProgrammaticWallpaper(adObject as IXandrBannerAdObject);
        },
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9797504,
      sizes: [
        [160, 600],
        [160, 350],
        [150, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Talouselama.fi_ROS_300x600|160x600|150x350_oikea1_(torni,pidennetty suurtaulu,suurtaulu)",
      prebid: {
        active: true,
        source: "Talouselama_ROS_WideSkyscraper",
      },
    },
    {
      divId: "almad-rectangle-1",
      placementId: 13027773,
      sizes: [
        [300, 300],
        [300, 250],
        [300, 431],
        [300, 600],
        [9, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName: "Talouselama.fi_ROS_300x300|300x250|300x431|300x600_palsta",
      prebid: {
        active: true,
        source: "Talouselama_ROS_MediumRectangle",
      },
      native: {
        template: "native_linkedin_ad",
      },
    },
    {
      divId: "almad-interstitial-1",
      placementId: 12948780,
      sizes: [[7, 1]],
      friendlyName: "Talouselama.fi_ROS_digietusivu_desktop",
    },
  ],
  desktop_section: {
    source: "desktop_section_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1"],
    add: [{
      divId: "almad-mobileParade-1",
      placementId: 9796444,
      sizes: [
        [320, 320],
        [300, 431],
        [320, 300],
        [300, 250],
        [300, 300],
        [300, 150],
        [2, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName: "Talouselama.fi_ROS_300x300_ylä_mobile",
      prebid: {
        active: true,
        source: "Talouselama_ROS_Square_Top_MobileWeb",
      },
      native: {
        template: "native_linkedin_ad",
      },
    }]
  },
  desktop_article_wide: [
    {
      divId: "almad-wallpaper-1",
      placementId: 13655196,
      sizes: [[1600, 1200]],
      friendlyName: "Talouselama.fi_ROS_1600x1200_(dynaaminen tapetti)",
    },
    {
      divId: "almad-giantBox-1",
      placementId: 9797505,
      sizes: [
        [490, 600],
        [490, 400],
        [468, 672],
        [468, 600],
        [468, 400],
        [300, 300],
        [300, 250],
        [320, 320],
        [320, 300],
        [4, 1],
      ],
      adType: ["banner", "native"],
      friendlyName:
        "Talouselama.fi_ROS_468x400|300x250_yla2_(jättiboksi,boksi)",
      prebid: {
        active: true,
        source: "Talouselama_ROS_NordicGiantRectangle",
      },
      native: {
        template: "native_rectangle_orange",
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 9797509,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [2, 1],
        [2, 2],
      ],
      friendlyName:
        "Talouselama.fi_ROS_980x400|980x120|728x90_yla2_(paraati,panorama,jättibanneri)",
      prebid: {
        active: true,
        source: "Talouselama_ROS_NordicParade",
      },
      customNeeds: {
        adAvailable: (context, adObject): void => {
          detectProgrammaticWallpaper(adObject as IXandrBannerAdObject);
        },
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9797504,
      sizes: [
        [160, 600],
        [160, 350],
        [150, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Talouselama.fi_ROS_300x600|160x600|150x350_oikea1_(torni,pidennetty suurtaulu,suurtaulu)",
      prebid: {
        active: true,
        source: "Talouselama_ROS_WideSkyscraper",
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 11292100,
      sizes: [[1, 1]],
      friendlyName: "Talouselama.fi_outstream_desktop",
      adType: "video",
    },
    {
      divId: "almad-rectangle-1",
      placementId: 13027773,
      sizes: [
        [300, 300],
        [300, 250],
        [300, 431],
        [300, 600],
        [9, 1],
        [1, 1],
      ],
      friendlyName: "Talouselama.fi_ROS_300x300|300x250|300x431|300x600_palsta",
      prebid: {
        active: true,
        source: "Talouselama_ROS_MediumRectangle",
      },
    },
    {
      divId: "almad-sima-1",
      lazyload: {
        disable: true,
      },
      placementId: 13033980,
      sizes: [[1, 1]],
      friendlyName: "Talouselama.fi_SIMA_1x1",
    },
    {
      divId: "almad-interstitial-1",
      placementId: 12948780,
      sizes: [[7, 1]],
      friendlyName: "Talouselama.fi_ROS_digietusivu_desktop",
    },
  ],
  desktop_article: {
    source: "desktop_article_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1"],
    add: [{
      divId: "almad-mobileParade-1",
      placementId: 9796444,
      sizes: [
        [320, 320],
        [300, 431],
        [320, 300],
        [300, 250],
        [300, 300],
        [300, 150],
        [2, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName: "Talouselama.fi_ROS_300x300_ylä_mobile",
      prebid: {
        active: true,
        source: "Talouselama_ROS_Square_Top_MobileWeb",
      },
      native: {
        template: "native_linkedin_ad",
      },
    }]
  },
  mobile_section: [
    {
      divId: "almad-mobileParade-1",
      placementId: 9796444,
      sizes: [
        [320, 320],
        [300, 431],
        [320, 300],
        [300, 250],
        [300, 300],
        [300, 150],
        [2, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName: "Talouselama.fi_ROS_300x300_ylä_mobile",
      prebid: {
        active: true,
        source: "Talouselama_ROS_Square_Top_MobileWeb",
      },
      native: {
        template: "native_linkedin_ad",
      },
    },
    {
      divId: "almad-mobileParade-2",
      placementId: 9796443,
      sizes: [
        [300, 300],
        [320, 300],
        [320, 320],
        [300, 250],
        [300, 600],
        [300, 431],
        [300, 150],
        [2, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName: "Talouselama.fi_ROS_300x300|300x600|300x431_keski_mobile",
      prebid: {
        active: true,
        source: "Talouselama_ROS_Square_Middle_MobileWeb",
      },
      native: {
        templateSelector: (context, adObject) => {
          if (nativeLinkedInConditions(adObject)) {
            return "native_linkedin_ad";
          }
          return "native_rectangle_orange";
        },
      },
    },
    {
      divId: "almad-interstitial-1",
      placementId: 12982589,
      sizes: [[7, 1]],
      friendlyName: "Talouselama.fi_ROS_digietusivu_mobile",
    },
  ],
  mobile_article: [
    {
      divId: "almad-mobileParade-1",
      placementId: 9796444,
      sizes: [
        [320, 320],
        [300, 431],
        [320, 300],
        [300, 300],
        [300, 250],
        [300, 150],
        [2, 1],
      ],
      friendlyName: "Talouselama.fi_ROS_300x300_ylä_mobile",
      prebid: {
        active: true,
        source: "Talouselama_ROS_Square_Top_MobileWeb",
      },
    },
    {
      divId: "almad-mobileParade-2",
      placementId: 9796443,
      sizes: [
        [300, 300],
        [320, 300],
        [320, 320],
        [300, 250],
        [300, 600],
        [300, 431],
        [300, 150],
        [2, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName: "Talouselama.fi_ROS_300x300|300x600|300x431_keski_mobile",
      prebid: {
        active: true,
        source: "Talouselama_ROS_Square_Middle_MobileWeb",
      },
      native: {
        templateSelector: (context, adObject) => {
          if (nativeLinkedInConditions(adObject)) {
            return "native_linkedin_ad";
          }
          return "native_rectangle_orange";
        },
      },
    },
    {
      divId: "almad-interstitial-1",
      placementId: 12982589,
      sizes: [[7, 1]],
      friendlyName: "Talouselama.fi_ROS_digietusivu_mobile",
    },
    {
      divId: "almad-outstream-1",
      placementId: 11292101,
      sizes: [[1, 1]],
      friendlyName: "Talouselama.fi_outstream_mobile",
      adType: "video",
    },
    {
      divId: "almad-sima-1",
      lazyload: {
        disable: true,
      },
      placementId: 13033980,
      sizes: [[1, 1]],
      friendlyName: "Talouselama.fi_SIMA_1x1",
    },
  ],
  fallback_section: [
    {
      divId: "almad-wallpaper-1",
      placementId: 13655196,
      sizes: [[1600, 1200]],
      friendlyName: "Talouselama.fi_ROS_1600x1200_(dynaaminen tapetti)",
    },
    {
      divId: "almad-giantBox-1",
      placementId: 9797505,
      sizes: [
        [490, 600],
        [490, 400],
        [468, 672],
        [468, 600],
        [468, 400],
        [320, 300],
        [300, 250],
        [4, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName:
        "Talouselama.fi_ROS_468x400|300x250_yla2_(jättiboksi,boksi)",
      prebid: {
        active: true,
        source: "Talouselama_ROS_NordicGiantRectangle",
      },
      native: {
        template: "native_rectangle_orange",
      },
    },
    {
      divId: "almad-giantBox-2",
      placementId: 12157134,
      sizes: [
        [490, 600],
        [490, 400],
        [468, 600],
        [468, 400],
        [300, 300],
        [300, 250],
        [320, 320],
        [320, 300],
        [4, 2],
      ],
      friendlyName:
        "Talouselama.fi_ROS_468x400|300x250_sima_(jättiboksi,boksi)",
      prebid: {
        active: true,
        source: "Talouselama_ROS_NordicGiantRectangle",
      },
      lazyload: {
        offset: {
          top: -200,
          bottom: 100,
        },
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 9797509,
      sizes: [
        [980, 600],
        [980, 552],
        [980, 400],
        [2, 2],
        [2, 1],
      ],
      friendlyName:
        "Talouselama.fi_ROS_980x400|980x120|728x90_yla2_(paraati,panorama,jättibanneri)",
      prebid: {
        active: true,
        source: "Talouselama_ROS_NordicParade",
      },
      customNeeds: {
        adAvailable: (context, adObject): void => {
          detectProgrammaticWallpaper(adObject as IXandrBannerAdObject);
        },
      },
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9797504,
      sizes: [
        [160, 600],
        [160, 350],
        [150, 350],
        [140, 350],
        [3, 1],
      ],
      friendlyName:
        "Talouselama.fi_ROS_300x600|160x600|150x350_oikea1_(torni,pidennetty suurtaulu,suurtaulu)",
      prebid: {
        active: true,
        source: "Talouselama_ROS_WideSkyscraper",
      },
    },
    {
      divId: "almad-mobileParade-1",
      placementId: 9796444,
      sizes: [
        [320, 320],
        [300, 431],
        [320, 300],
        [300, 250],
        [300, 300],
        [300, 600],
        [300, 150],
        [2, 1],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName: "Talouselama.fi_ROS_300x300_ylä_mobile",
      prebid: {
        active: true,
        source: "Talouselama_ROS_Square_Top_MobileWeb",
      },
      native: {
        template: "native_linkedin_ad",
      },
    },
    {
      divId: "almad-mobileParade-2",
      placementId: 9796443,
      sizes: [
        [320, 320],
        [320, 300],
        [300, 300],
        [300, 250],
        [300, 431],
        [300, 150],
        [300, 600],
        [2, 2],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName: "Talouselama.fi_ROS_300x300|300x600|300x431_keski_mobile",
      prebid: {
        active: true,
        source: "Talouselama_ROS_Square_Middle_MobileWeb",
      },
      native: {
        templateSelector: (context, adObject) => {
          if (nativeLinkedInConditions(adObject)) {
            return "native_linkedin_ad";
          }
          return "native_rectangle_orange";
        },
      },
    },
    {
      divId: "almad-outstream-1",
      placementId: 11292100,
      sizes: [[1, 1]],
      friendlyName: "Talouselama.fi_outstream_desktop",
      adType: "video",
    },
  ],
};

export default talouselamaPlacements;
